/**
 * Password input with a show/hide eye toggle. Drop-in replacement for a
 * plain <input type="password" /> — matches the existing form styles used
 * across AuthPage and SavePortraitCTA.
 */
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const PasswordInput = ({
  value,
  onChange,
  placeholder,
  autoComplete = "current-password",
  required = false,
  className = "",
  testId,
}) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative w-full">
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        className={`w-full pr-11 ${className}`}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-[#6B6B6B] hover:text-[#1A1A1A]"
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        tabIndex={-1}
      >
        {show ? <EyeOff size={18} strokeWidth={1.6} /> : <Eye size={18} strokeWidth={1.6} />}
      </button>
    </div>
  );
};

export default PasswordInput;
